import React from 'react';
interface FigureCardProps {
  number: number;
  title: string;
  subtitle: string;
  caption?: string;
  children: React.ReactNode;
}
export function FigureCard({
  number,
  title,
  subtitle,
  caption,
  children
}: FigureCardProps) {
  return <section className="bg-white border border-[#E5E0D6] shadow-[0_1px_2px_rgba(0,0,0,0.04)] rounded-sm overflow-hidden" data-id="element-424">
      <header className="px-8 pt-8 pb-4 border-b border-[#F0EBE0]" data-id="element-425">
        <div className="flex items-baseline gap-3 mb-2" data-id="element-426">
          <span className="font-sans text-[10px] tracking-[0.18em] uppercase text-[#8B2500] font-semibold" data-id="element-427">
            Figure {number}
          </span>
          <span className="h-px flex-1 bg-[#E5E0D6]" data-id="element-428" />
        </div>
        <h2 className="font-serif text-[22px] leading-snug text-[#1B1B1B] font-semibold" data-id="element-429">
          {title}
        </h2>
        <p className="font-serif italic text-[14px] text-[#5B5448] mt-2 max-w-3xl" data-id="element-430">
          {subtitle}
        </p>
      </header>
      <div className="px-6 py-8" data-id="element-431">{children}</div>
      {caption && <footer className="px-8 py-4 bg-[#FBFAF6] border-t border-[#F0EBE0]" data-id="element-432">
          <p className="font-serif text-[12px] text-[#5B5448] italic leading-relaxed" data-id="element-433">
            {caption}
          </p>
        </footer>}
    </section>;
}